import fetch from './fetch'

export default {
  getCseit (payload) {
    let request = fetch({
      url: `/cseit/`,
      method: 'get',
      data: {},
      payload
    })
    return request.call()
  },
  createCseit (payload) {
    let request = fetch({
      url: `/cseit/`,
      method: 'post',
      data: payload
    })
    return request.call()
  },
  getCseitQuestion (payload) {
    let request = fetch({
      url: `/view/cseitquestion/`,
      method: 'get',
      data: {},
      payload
    })
    return request.call()
  },
  updateCseit (payload) {
    const cseitId = payload._id
    const toOmit = [
      'id',
      '_id',
      'sharingRecords',
      'sharingGroups',
      'createdAt',
      'createdBy',
      'timestamp',
      'updatedAt',
      'updatedBy',
      'externalPersonIds'
    ]
    const data = _.omit(payload, toOmit)

    /* // Flatten our associations
    const associations = [
      'organization'
    ]
    _.each(associations, function (assoc) {
      // We forgot to flatten our assocation(s)
      if (data[assoc] && _.isObject(data[assoc])) {
        data[assoc] = data[assoc].id
      } else {
        delete data[assoc]
      }
    }) */

    let request = fetch({
      url: `/cseit/` + cseitId,
      method: 'patch',
      data: data
    })

    return request.call()
  }
}



// WEBPACK FOOTER //
// ./src/api/cseit.js